module.exports = __webpack_public_path__ + "static/media/checked.49e0c574.svg";